import { useQuery, QueryFunction } from 'react-query';
import {
    getDashboardValidationStats,
    DashboardValidationStats,
    DashboardValidationResponse,
    AbsentReportsData,
    getAbsentReportsStats,
    AbsentReportsResponse,
    DailyExpense,
    MonthlyExpensesResponse,
    getMonthlyExpenses,
} from '../../services/apiSLTP/dashboard/dashboard';

type UseDashboardValidationQueryOptions = {
    date: string;
};

const getDashboardValidationQuery: QueryFunction<DashboardValidationStats[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseDashboardValidationQueryOptions];
    const { date } = options;

    const response = await getDashboardValidationStats(date);
    return response.data;
};

export const useDashboardValidationQuery = (options: UseDashboardValidationQueryOptions) => {
    return useQuery(['dashboardValidation', options], getDashboardValidationQuery);
};

type UseAbsentReportsQueryOptions = {
    date: string;
};

const getAbsentReportsQuery: QueryFunction<AbsentReportsData> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseAbsentReportsQueryOptions];
    const { date } = options;

    const response: AbsentReportsResponse = await getAbsentReportsStats(date);
    return response.data;
};

export const useAbsentReportsQuery = (options: UseAbsentReportsQueryOptions) => {
    return useQuery(['dashboardAbsentReports', options], getAbsentReportsQuery);
};

type UseMonthlyExpensesQueryOptions = {
    date: string; // n'importe quel jour du mois
};

const getMonthlyExpensesQuery: QueryFunction<DailyExpense[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlyExpensesQueryOptions];
    const { date } = options;

    const response: MonthlyExpensesResponse = await getMonthlyExpenses(date);
    return response.data;
};

export const useMonthlyExpensesQuery = (options: UseMonthlyExpensesQueryOptions) => {
    return useQuery(['dashboardMonthlyExpenses', options], getMonthlyExpensesQuery);
};
